import { ContractorDeliveryPriceCreate } from '../ContractorDeliveryPrice.entity';

export const CONTRACTOR_DELIVERY_PRICE_CRATE: ContractorDeliveryPriceCreate = {
  contractorId: null,
  dateBegin: undefined,
  factoryId: null,
  maxQuantity: 1,
  objectId: null,
  price: null,
};
